
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Wann soll man sich die Hände waschen? So oft wie möglich. Vor der Zubereitung des Essens und vor
  dem Essen, nach dem WC, nach dem Schnäuzen, Niesen oder Husten, jedes Mal beim Nachhausekommen,
  nach dem Benutzen eines öffentlichen Verkehrsmittels, vor dem Einsetzen und dem Herausnehmen der
  Kontaktlinsen, nach Kontakt mit Tieren.
    </p>
    <p>Die WHO zeigt in einem Video, wie man sich die Hände richtig wäscht:</p>
    <iframe src='https://www.youtube.com/embed/3PmVJQUCm4E' width='100%' height='315' style={{
      border: 0
    }} />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;